import React from 'react';
import './LogoutProfile.css';

const LogoutProfile = ({ onClose, onConfirmLogout }) => {
  const handleConfirmLogout = () => {
    localStorage.removeItem('homeshiksha-jwt');
    localStorage.removeItem('userDetails');
    localStorage.clear();
    window.location.reload();

    if (onConfirmLogout) {
      onConfirmLogout();
    }

    onClose();
  };

  const handleCancelLogout = () => {
    onClose();
  };

  return (
    <div className="logout-modal-overlay">
      <div className="logout-modal">
        <div className="logout-content">
          <h2 className="logout-title">Do you want to Logout?</h2>
          <p className="logout-subtitle">Are you sure you want logout your account?</p>

          <div className="logout-buttons">
            <button className="logout-confirm-btn" onClick={handleConfirmLogout}>
              Confirm
            </button>
            <button className="logout-cancel-btn" onClick={handleCancelLogout}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutProfile;
